import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'eiq-card-form-selector',
  templateUrl: './card-form-selector.component.html',
  styleUrls: ['./card-form-selector.component.scss', './_card-form-selector-theme.component.scss']
})
export class CardFormSelectorComponent {
  @Input() style: 'light' | 'primary';
  @Output() clicked = new EventEmitter<void>();
}
